import { render, staticRenderFns } from "./HasWorkspace.vue?vue&type=template&id=2c6681de&"
import script from "./HasWorkspace.vue?vue&type=script&lang=ts&"
export * from "./HasWorkspace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports